import { NgModule } from '@angular/core';
import { MatButtonModule, MatCheckboxModule, MatTooltipModule, MatDialogModule, MatGridListModule } from '@angular/material';
import { MatInputModule, MatListModule, MatSnackBarModule, MatSelectModule, MatFormFieldModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule, MatExpansionModule } from '@angular/material';


@NgModule({
  imports: [MatButtonModule, MatCheckboxModule, MatTooltipModule, MatDialogModule, MatGridListModule, MatInputModule,
    MatListModule, MatSnackBarModule, MatSelectModule, MatFormFieldModule, MatDatepickerModule, MatNativeDateModule,
    MatExpansionModule],
  exports: [MatButtonModule, MatCheckboxModule, MatTooltipModule, MatDialogModule, MatGridListModule, MatInputModule,
    MatListModule, MatSnackBarModule, MatSelectModule, MatFormFieldModule, MatDatepickerModule, MatNativeDateModule,
    MatExpansionModule],
})

export class MaterialDesignModule { }




// WEBPACK FOOTER //
// /app/src/app/shared/material-design/material-design.module.ts